export const environment = {
  production: true,
  apiDomain: 'https://gesa.sapienslavoro.it',
  apiUrl: 'https://gesa.sapienslavoro.it/API/',
  apiUrlLogin: 'https://gesa.sapienslavoro.it/',
  apiUrlDocs: 'https://gesa.sapienslavoro.it',
  theme : 'sapiens'
};


// export const environment = {
//   production: true,
//   apiDomain: 'https://gespag.it',
//   apiUrl: 'https://gespag.it/API/',
//   apiUrlLogin: 'https://gespag.it/',
//   apiUrlDocs: 'https://gespag.it',
//   theme : 'gespag'
// };
